import { render, staticRenderFns } from "./notice-region.vue?vue&type=template&id=d596974c&scoped=true&"
import script from "./notice-region.vue?vue&type=script&lang=js&"
export * from "./notice-region.vue?vue&type=script&lang=js&"
import style0 from "./notice-region.vue?vue&type=style&index=0&id=d596974c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d596974c",
  null
  
)

export default component.exports